module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_wechat.c9fd1.png";